import axios from "axios";

class Filters {
  constructor() {
    // Selectors
    this.productsGrid = document.querySelector("#products-grid");
    this.filtersOpenButton = document.querySelector("#filters-open-button");
    this.filtersCloseButton = document.querySelector("#filters-close-button");
    this.filtersResetButton = document.querySelector("#filters-reset-button");
    this.filtersPopUp = document.querySelector("#filters-popup");
    this.validateFiltersButton = document.querySelector(
      "#validate-filters-button"
    );
    this.attributeButtons = document.querySelectorAll(".attribute-button");
    this.filtersParams = document.querySelector("#filters-params");
    // Vars
    this.reset = false;
    this.args = [];
    this.argsCategories = [];
    this.argsColors = [];
    this.argsSizes = [];
    this.argsString = "";
    this.filteredProducts = [];
    this.secretKey = "ck_17eeab4c7d09340ce6774bd835d6539bcfa2d0f6";
    this.consumerSecret = "cs_215093bcdecbbeed9d1086d30198496ef9db690f";
    // Fn
    // this.displayFiltersParams();
    this.events();

    // this.fetchFilteredProducts();
  }

  events() {
    this.filtersOpenButtonClicked();
    this.filtersCloseButtonClicked();
    this.filtersResetButtonClicked();
    this.filtersValidateButtonClicked();
    this.attributeButtonClicked();
  }

  filtersOpenButtonClicked() {
    if (this.filtersOpenButton && this.filtersPopUp) {
      this.filtersOpenButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.filtersPopUp.classList.remove("hidden");
        document.body.style.overflow = "hidden";
      });
    }
  }

  filtersCloseButtonClicked() {
    if (this.filtersCloseButton && this.filtersPopUp) {
      this.filtersCloseButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideFiltersPopup();
      });
    }
  }

  filtersResetButtonClicked() {
    if (this.filtersResetButton && this.filtersPopUp) {
      this.filtersResetButton.addEventListener("click", (e) => {
        e.preventDefault();
        // this.reset = true;
        // this.hideFiltersPopup();
        // this.fetchFilteredProducts();
        window.location.reload();
      });
    }
  }

  filtersValidateButtonClicked() {
    if (this.validateFiltersButton) {
      this.validateFiltersButton.addEventListener("click", (e) => {
        e.preventDefault();
        // window.history.pushState("object or string", "Title", "/boutique/?product-category=clothing");
        // window.location.reload();
        this.hideFiltersPopup();
        this.fetchFilteredProducts();
        // this.argsString = `?category=${this.argsCategories.join(',')}&filter[pa_size]=${this.argsSizes.join(',')}&filter[pa_color]=${this.argsColors.join(',')}`;
        // console.log(this.argsString);
      });
    }
  }

  attributeButtonClicked() {
    // const classes = ['active', 'border-solid', 'border-orangee'];
    if (this.attributeButtons.length) {
      this.attributeButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          this.addOrRemoveArgs(button);
        });
      });
    }
  }

  addOrRemoveArgs(button) {
    // const classes = ["active", "border-solid", "border-orangee"];
    const classes = ["active"];
    // If button value not in args list, append it ELSE remove it from args list
    // (button.value.length && !((this.args).includes(button.value))) ? this.args.push(button.value) : (button.value.length && (this.args).includes(button.value)) && this.args.splice((this.args).indexOf(button.value), 1);
    // Add/Remove classes (styles) if selected/unselected
    button.classList.contains("active")
      ? button.classList.remove(...classes)
      : button.classList.add(...classes);
    button.classList.contains("active")
      ? (button.style.border = "1px solid black")
      : (button.style.border = "1px solid transparent");

    // If button clicked is a category filter
    if (button.id.includes("product_cat")) {
      !this.argsCategories.includes(button.value)
        ? this.argsCategories.push(button.value)
        : this.argsCategories.splice(
            this.argsCategories.indexOf(button.value),
            1
          );
    }

    // If button clicked is a color
    if (button.id.includes("filter[pa_couleur]")) {
      !this.argsColors.includes(button.value)
        ? this.argsColors.push(button.value)
        : this.argsColors.splice(this.argsColors.indexOf(button.value), 1);
    }

    // If button clicked is a size
    if (button.id.includes("filter[pa_taille]")) {
      !this.argsSizes.includes(button.value)
        ? this.argsSizes.push(button.value)
        : this.argsSizes.splice(this.argsSizes.indexOf(button.value), 1);
    }
  }

  // displayFiltersParams() {
  //     if (this.filtersParams && this.args) {
  //         this.filtersParams.innerHTML = this.args;
  //     }
  // }

  hideFiltersPopup() {
    this.filtersPopUp.classList.add("hidden");
    document.body.style.overflow = "auto";
  }

  fetchFilteredProducts() {
    if (this.productsGrid) {
      this.productsGrid.classList =
        "z-[0] grid grid-cols-12 max-w-[1675px] px-11 mx-auto my-[186px] gap-x-4 gap-y-20 w-full";
      this.getResults();
    }
  }

  async getResults() {
    try {
      // const response = await axios.get(`https://${window.location.hostname}/wp-json/wc/v3/products?consumer_key=${this.secretKey}&consumer_secret=${this.consumerSecret}`)
      const response = await axios.get(
        `https://${window.location.hostname}/wp-json/pycofa/v1/products/${
          this.reset ? "" : this.returnQueryUrlParameters()
        }`
      );
      console.log(
        `https://${window.location.hostname}/wp-json/pycofa/v1/products/${
          this.reset ? "" : this.returnQueryUrlParameters()
        }`
      );
      this.productsGrid.innerHTML = "";
      const results = response.data;
      if (results.length > 0) {
        this.productsGrid.innerHTML = results
          .map(
            (product) => /*html*/ `
                    <div class='col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 z-10'>
                        <a href="${product["permalink"]}">
                            <div style='md:max-width: 366px; min-height: 560px; max-height: 560px; width: 100%; background-position: center center; background-size: cover; background-image: url(${product["image"]})'></div>
                            <h2 class="mb-0 text-xs font-montserrat font-bold text-black uppercase">${product["name"]}</h2>
                            <h3 class="mt-0 text-xs font-montserrat font-normal text-gray-600 uppercase">${product["short_description"]}</h3>
                        </a>
                    </div>
                    `
          )
          .join("");
        const height = document.body.clientHeight;
        const circle = document.querySelectorAll(".circle");
        console.log(height);
        if (height >= 5000 && circle) {
          circle.forEach((element) => {
            element.classList.remove("hidden");
          });
        } else {
          circle.forEach((element) => {
            element.classList.add("hidden");
          });
        }
      } else {
        this.productsGrid.innerHTML = /*html*/ `
                    <div class="col-span-12 text-center">
                        <p class="text-2xl uppercase md:text-4xl font-bonvivant">Votre recherche n'a abouti à aucun résultats.</p>
                        <p class="text-lg md:text-xl">Veuillez réessayer avec d'autres filtres.</p>
                    </div>
                    `;
        const height = document.body.clientHeight;
        const circle = document.querySelectorAll(".circle");
        console.log(height);
        if (height >= 5000 && circle) {
          circle.forEach((element) => {
            element.classList.remove("hidden");
          });
        } else {
          circle.forEach((element) => {
            element.classList.add("hidden");
          });
        }
      }
      // this.isSpinnerVisible = false
    } catch (e) {
      console.log(e);
    }
  }

  returnQueryUrlParameters() {
    const categoriesString = this.argsCategories.length
      ? `category=${this.argsCategories.join(",")}`
      : "";
    const colorsString = this.argsColors.length
      ? `filter[pa_couleur]=${this.argsColors.join(",")}`
      : "";
    const sizesString = this.argsSizes.length
      ? `filter[pa_taille]=${this.argsSizes.join(",")}`
      : "";
    const finalString = `?${categoriesString}&${colorsString}&${sizesString}`;
    return finalString;
  }
}

export default Filters;
